<template>
  <UserList search-type="4" />
</template>

<script>
import UserList from '@/components/UserList'

export default {
  name: 'NearByUsers',
  components: {
    UserList,
  }
}
</script>
